(() => {
  'use strict';
  function init(root) {
    if (root.dataset.enhanced) return;
    const form = root.querySelector('[data-astra-facet-form]');
    const sort = root.querySelector('[data-astra-sort]');
    const dialog = root.querySelector('[data-astra-filter-dialog]');
    const opener = root.querySelector('[data-astra-filter-open]');
    const content = root.querySelector('[data-astra-filter-content]');
    const home = root.querySelector('[data-astra-filter-home]');
    if (!form) return;
    if (!dialog || typeof dialog.showModal === 'function') root.dataset.enhanced = 'true';
    form.addEventListener('submit', () => {
      form.querySelectorAll('input[type=number]').forEach(input => {input.disabled = input.value === '';});
    });
    sort?.addEventListener('change', () => form.requestSubmit());
    let oldOverflow = '';
    opener?.addEventListener('click', () => {
      if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
      dialog.querySelector('[data-astra-filter-slot]').append(content);
      oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
    });
    dialog?.querySelector('[data-astra-filter-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('close', () => {
      home.append(content);
      document.body.style.overflow = oldOverflow;
      if (window.matchMedia('(max-width: 1024px)').matches) opener.focus();
    });
    dialog?.addEventListener('click', event => {if (event.target === dialog) {const rect = dialog.getBoundingClientRect();if (event.clientX < rect.left || event.clientX > rect.right) dialog.close();}});
    const desktop = window.matchMedia('(min-width: 1025px)');
    desktop.addEventListener('change', () => {if (desktop.matches && dialog?.open) dialog.close();});
    window.addEventListener('pageshow', () => {form.querySelectorAll('input[type=number]').forEach(input => {input.disabled = false;});});
  }
  const start = () => document.querySelectorAll('[data-astra-collection]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',start);
})();
